<!-- Filters toolbar (when showFilters) -->
<div class="bids-filters-toolbar" *ngIf="showFilters">
  <div class="filter-group" *ngIf="showStatusColumn">
    <label>Status</label>
    <select
      [(ngModel)]="filterStatus"
      (ngModelChange)="applyFiltersAndSort()">
      <option value="">All</option>
      <option value="pending">Pending</option>
      <option value="invalid">Invalid</option>
    </select>
  </div>
  <div class="filter-group">
    <label>Source</label>
    <select
      [(ngModel)]="filterSource"
      (ngModelChange)="applyFiltersAndSort()">
      <option value="">All</option>
      <option *ngFor="let s of uniqueSources" [value]="s">{{ s }}</option>
    </select>
  </div>
  <div class="filter-group">
    <label>Bidder</label>
    <input
      type="text"
      [(ngModel)]="filterBidder"
      (ngModelChange)="applyFiltersAndSort()"
      placeholder="Address (partial)" />
  </div>
  <button type="button" class="clear-filters-btn" (click)="clearFilters()">Clear</button>
</div>

<div class="bids-table-wrapper">
  <table class="bids-table">
    <thead>
      <tr>
        <th [class.sortable]="showFilters" (click)="showFilters && setSort('bidder')">
          Bidder <span *ngIf="showFilters" class="sort-icon">{{ getSortIcon('bidder') }}</span>
        </th>
        <th class="bid-type-header">Bid Type</th>
        <th
          *ngIf="displayExpiresColumn"
          [class.sortable]="showFilters"
          (click)="showFilters && setSort('expires')">
          Expires <span *ngIf="showFilters" class="sort-icon">{{ getSortIcon('expires') }}</span>
        </th>
        <th class="amount-header" [class.sortable]="showFilters" (click)="showFilters && setSort('amount')">
          Amount <span *ngIf="showFilters" class="sort-icon">{{ getSortIcon('amount') }}</span>
        </th>
        <th *ngIf="showPunksColumn" class="punks-header">Punks</th>
        <th *ngIf="showStatusColumn" class="status-header" [class.sortable]="showFilters" (click)="showFilters && setSort('status')">
          Status <span *ngIf="showFilters" class="sort-icon">{{ getSortIcon('status') }}</span>
        </th>
        <th class="action-header">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let bid of getPaginatedBids(); let i = index" [class.highest-bid]="i === 0">
        <td class="bidder-cell">
          <div class="bidder-cell-wrapper">
            <app-address-avatar [address]="bid.bidder_address"></app-address-avatar>
            <div class="bidder-addresses">
              <div class="bidder-address-row">
                <a [routerLink]="['/', 'user', bid.bidder_address]">
                  <app-wallet-address [address]="bid.bidder_address"></app-wallet-address>
                </a>
              </div>
              <div class="stash-address-row" *ngIf="bid.stashAddress">
                <span class="stash-prefix">L&nbsp;</span>
                <a
                  [href]="'https://etherscan.io/address/' + bid.stashAddress"
                  target="_blank"
                  rel="noopener noreferrer">
                  <app-wallet-address [address]="bid.stashAddress" [maxVisibleChars]="14"></app-wallet-address>
                </a>
              </div>
            </div>
          </div>
        </td>
        <td class="bid-type-cell">
          <div>
            <div *ngIf="bid.confidential" class="confidential-pill" title="Confidential bid">
              <svg style="transform: scale(1.4);" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
              <span>Confidential</span> 
            </div>
            <div
              *ngIf="bid.stash_funded === 0"
              class="unfunded-pill"
              title="Stash balance is below this bid amount">
              unfunded
            </div>
            <span
              class="bid-type-pill"
              [class.trait]="bid.bidType === 'trait'"
              [class.custom]="bid.bidType === 'custom'"
              [class.owner]="bid.bidType === 'owner'"
              [class.collection]="bid.bidType === 'collection'"
              [class.legacy]="bid.bidType === 'legacy' || bid.isLegacyBid"
              [class.punksmarket]="isPunksmarketBidRow(bid)">
              {{ bid.bidTypeLabel || (bid.bidType === 'punksmarket' ? onChainBidTypeLabel : bid.bidType === 'trait' ? 'Trait Bid' : bid.bidType === 'owner' ? 'Owner Bid' : bid.bidType === 'custom' ? 'Custom Bid' : bid.bidType === 'legacy' || bid.isLegacyBid ? nativeBidTypeLabel : 'Collection Bid') }}
              <app-on-chain-bid-info-icon
                *ngIf="isPunksmarketBidRow(bid)"
                [iconSize]="14"
                [insetInPill]="true" />
            </span>
            <ng-container *ngIf="bid.bidType === 'owner' && bid.ownerAddress">
              <div class="tags-list">
                <a class="tag-pill owner-link" [routerLink]="['/', 'user', bid.ownerAddress]">
                  Owner: <app-wallet-address [address]="bid.ownerAddress"></app-wallet-address>
                </a>
              </div>
            </ng-container>
            <ng-container *ngIf="bid.decodedTags?.length && bid.bidType !== 'custom' && bid.bidType !== 'owner'">
              <div class="tags-list">
                <span class="tag-pill" *ngFor="let tag of bid.decodedTags">{{ tag }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="isPunksmarketBidRow(bid) && bid.biddingOn && !bid.decodedTags?.length">
              <div class="tags-list">
                <span class="tag-pill">{{ bid.biddingOn }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="(bid.bidType === 'custom') && (bid.punkIndices?.length || bid.punk_indices_count)">
              <div class="tags-list tags-list-preview">
                <span class="tag-pill" *ngFor="let idx of bid.punkIndices">
                  #{{ idx }}
                  <div class="punk-popup">
                    <img 
                      [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (idx | tokenIdParse) + '.svg'"
                      [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                      width="30" 
                      height="30" />
                  </div>
                </span>
                <span class="tag-pill tag-pill-more" *ngIf="(bid.punk_indices_count ?? bid.punkIndices?.length ?? 0) > 3">+ {{ (bid.punk_indices_count ?? bid.punkIndices?.length ?? 0) - 3 }}</span>
              </div>
            </ng-container>
            <!-- Matching punks frise (shown inline when punks column is not enabled) -->
            <div *ngIf="!showPunksColumn && bid.displayPunkIds && bid.displayPunkIds.length > 0" class="matching-punks-frise">
              <div class="punks-frise-container">
                <div 
                  *ngFor="let punkId of bid.displayPunkIds.slice(0, 7); trackBy: trackByPunkId" 
                  class="punk-frise-item"
                  [routerLink]="['/', 'details', punkId]"
                  (click)="$event.stopPropagation()">
                  <img 
                    [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
                    [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                    width="30" 
                    height="30"
                    [alt]="'Punk ' + punkId" />
                </div>
                <span *ngIf="bid.displayPunkIds && bid.displayPunkIds.length > 7" class="more-punks-indicator">
                  and {{ bid.displayPunkIds.length - 7 }} more
                </span>
              </div>
            </div>
          </div>
        </td>
        <td *ngIf="displayExpiresColumn" class="expires-cell">
          <ng-container *ngIf="!isPunksmarketBid(bid)">
          <span>{{ bid.expires_at ? (bid.expires_at | date) : '-' }}</span>
          <span
            *ngIf="bid.expires_at"
            class="expires-info-icon"
            tippy
            [options]="{
              content: (bid.expires_at | date:'short') || '',
              placement: 'top',
              theme: 'punks'
            }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
            </svg>
          </span>
          <!-- Debug mode icon -->
          <span 
            *ngIf="!environment.production" 
            class="debug-icon"
            (click)="copyBidJson(bid, $event)"
            [title]="'Bid ID: ' + bid.id">
            (i)
          </span>
          </ng-container>
        </td>
        <td class="bid-amount-cell">
          <div class="amount-value-wrapper">
            <!-- number:'1.2-2' rounds 0.0001 to 0.00 — use more decimals for sub-cent ETH bids -->
            <div class="amount-value">
              <ng-container *ngIf="(bid.bid_amount_eth || 0) > 0 && (bid.bid_amount_eth || 0) < 0.01; else stashBidEthNormal">
                {{ bid.bid_amount_eth | number:'1.2-8' }}&nbsp;ETH
              </ng-container>
              <ng-template #stashBidEthNormal>
                {{ bid.bid_amount_eth | number:'1.2-2' }}&nbsp;ETH
              </ng-template>
            </div>
            <ng-container *ngIf="bid._platformIcon as iconSrc">
              <div 
                *ngIf="bid._platformTooltip as tooltipText; else noTooltipIcon"
                class="platform-icon-wrapper"
                tippy
                [options]="{ content: tooltipText, placement: 'top', theme: 'punks' }">
                <img 
                  [src]="iconSrc"
                  [alt]="(bid.source || 'Stash') + ' platform icon'"
                  class="platform-icon" />
              </div>
              <ng-template #noTooltipIcon>
                <div class="platform-icon-wrapper">
                  <img 
                    [src]="iconSrc"
                    [alt]="(bid.source || 'Stash') + ' platform icon'"
                    class="platform-icon" />
                </div>
              </ng-template>
            </ng-container>
          </div>
        </td>
        <td *ngIf="showPunksColumn" class="punks-cell">
          <div *ngIf="bid.displayPunkIds && bid.displayPunkIds.length > 0" class="matching-punks-frise">
            <div class="punks-frise-container">
              <div 
                *ngFor="let punkId of bid.displayPunkIds.slice(0, 7); trackBy: trackByPunkId" 
                class="punk-frise-item"
                [routerLink]="['/', 'details', punkId]"
                (click)="$event.stopPropagation()">
                <img 
                  [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
                  [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                  width="30" 
                  height="30"
                  [alt]="'Punk ' + punkId" />
              </div>
              <span *ngIf="bid.displayPunkIds.length > 7" class="more-punks-indicator">
                +{{ bid.displayPunkIds.length - 7 }}
              </span>
            </div>
          </div>
          <span *ngIf="!bid.displayPunkIds || bid.displayPunkIds.length === 0" class="no-punks">-</span>
        </td>
        <td *ngIf="showStatusColumn" class="status-cell">
          <div class="status-cell-content">
            <span
              class="status-pill"
              [class.active]="bid.uiStatusKind === 'active'"
              [class.expired]="bid.uiStatusKind === 'expired'"
              [class.cancelled]="bid.uiStatusKind === 'cancelled'">
              {{ bid.uiStatusLabel || '-' }}
            </span>
          </div>
        </td>
        <td class="action-cell">
          <div class="action-buttons">
            <button 
              class="copy-id-btn icon-btn"
              [class.copied]="copiedBidId === bid.id"
              (click)="copyBidId(bid, $event)"
              tippy
              [options]="{ content: copiedBidId === bid.id ? 'Copied!' : 'Copy bid ID', placement: 'bottom', theme: 'punks' }">
              <svg *ngIf="copiedBidId !== bid.id" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/>
              </svg>
              <svg *ngIf="copiedBidId === bid.id" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/>
              </svg>
            </button>
            <button
              *ngIf="bid.showCloneBidButton"
              class="copy-bid-btn icon-btn"
              (click)="onCopyBid(bid); $event.stopPropagation()"
              tippy
              [options]="{ content: cloneBidLabel, placement: 'bottom', theme: 'punks' }">
              <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                <path d="M480-240h80v-120h120v-80H560v-120h-80v120H360v80h120v120ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/>
              </svg>
            </button>
            <button
              *ngIf="showViewBidLogButton"
              class="view-log-btn icon-btn"
              (click)="openBidLogModal(bid); $event.stopPropagation()"
              tippy
              [options]="{ content: 'View bid log', placement: 'bottom', theme: 'punks' }">
              <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                <path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/>
              </svg>
            </button>
            <button 
              *ngIf="(!bid.isLegacyBid && bid.bidType !== 'legacy') || ((bid.isLegacyBid || bid.bidType === 'legacy') && bid.legacyBid?.transactionHash)"
              class="detail-bid-btn icon-btn"
              (click)="onShowBidDetails(bid)"
              tippy
              [options]="{
                content: (bid.isLegacyBid || bid.bidType === 'legacy') ? 'View on Etherscan' : 'View bid details',
                placement: 'bottom',
                theme: 'punks'
              }">
              <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18" fill="currentColor">
                <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Z"/>
              </svg>
            </button>

            <button
              *ngIf="canCancelBid(bid)"
              class="cancel-bid-btn icon-btn"
              (click)="onCancelBid(bid); $event.stopPropagation()"
              tippy
              [options]="{ content: 'Cancel this bid', placement: 'bottom', theme: 'punks' }">
              <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor">
                <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/>
              </svg>
            </button>
          </div>

          <div *ngIf="showAcceptButton && canAcceptBid(bid)" style="width: 100%;">
              
            <button 
              class="accept-bid-btn icon-btn"
              (click)="onAcceptBid(bid)"
              tippy
              [options]="{
                content: 'Accept this bid',
                placement: 'bottom',
                theme: 'punks'
              }">
              <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18" fill="currentColor">
                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/>
              </svg>              
              <span>Accept</span>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Pagination -->
<div class="pagination" *ngIf="showPagination && totalPages > 1">
  <button 
    class="page-btn"
    [class.disabled]="getDisplayedCurrentPage() === 1"
    (click)="goToPage(getDisplayedCurrentPage() - 1)"
    [disabled]="getDisplayedCurrentPage() === 1">
    ‹
  </button>
  <ng-container *ngFor="let item of getPaginationItems()">
    <span
      *ngIf="item === 'ellipsis'"
      class="page-ellipsis"
      aria-hidden="true">
      …
    </span>
    <span
      *ngIf="item !== 'ellipsis'"
      class="page-number"
      [class.active]="getDisplayedCurrentPage() === item"
      (click)="goToPage(item)">
      {{ item }}
    </span>
  </ng-container>
  <button 
    class="page-btn"
    [class.disabled]="getDisplayedCurrentPage() === totalPages"
    (click)="goToPage(getDisplayedCurrentPage() + 1)"
    [disabled]="getDisplayedCurrentPage() === totalPages">
    ›
  </button>
</div>

<!-- Bid Details Modal -->
<app-bid-details-modal
  [isActive]="bidDetailsModalActive"
  [bid]="selectedBidForDetails"
  (closed)="closeBidDetailsModal()"
  (copyBid)="onCopyBid($event)">
</app-bid-details-modal>

<!-- Bid Log Modal -->
<div class="bid-log-overlay" *ngIf="bidLogModalActive" (click)="closeBidLogModal()" role="button">
  <div class="bid-log-modal" (click)="$event.stopPropagation()" role="dialog" aria-labelledby="bid-log-title">
    <div class="bid-log-header">
      <h3 id="bid-log-title">Bid log</h3>
      <button type="button" class="bid-log-close" (click)="closeBidLogModal()" aria-label="Close">×</button>
    </div>
    <div class="bid-log-body">
      <pre class="bid-log-content">{{ selectedBidForLog?.log || 'No log available.' }}</pre>
    </div>
  </div>
</div>

